import Button from '@mui/material/Button'

type Props = {
  label: string,
  onClick?: () => void,
  disabled?: boolean,
  type?: string,
  className?: string,
  size?: 'small' | 'medium' | 'large',
  fullWidth?: boolean,
  color?: 'default' | 'danger'
}

export default function PrimaryButton({onClick, label, type, disabled, className = '', size, fullWidth = true, color = 'default'}: Props) {
  const bg = disabled ? 'grey' : (color === 'danger' ? '#F40000' : '#000');
  return (
    <Button 
      variant="text"
      size={size}
      className={`primary-button-component ${className}`}
      style={{
        backgroundColor: bg,
        width: fullWidth ? '100%' : 'auto',
        display: fullWidth ? 'block' as const : undefined
      }}
      onClick={onClick}
      type='submit'
      disabled={disabled}
    >
      {label}
    </Button>
  )
}
